<a
  *ngIf="item"
  attr.data-test-id="leftnav-submenu-{{ parentItem.text }}"
  #navItem
  mat-list-item
  role="listitem"
  tabindex="0"
  class="nav-item"
  (click)="navItemSubMenuClicked($event)"
  target="{{ item.icon === 'external-link' ? '_blank' : '_self' }}"
  [ngClass]="currentURL === '/' + item.route ? 'nav-item-activated' : ''"
>
  <div
    class="active-strip"
    [attr.data-test-id]="'snActiveRoutePage-' + idx"
  ></div>
  <div
    [ngClass]="
      (!isImpersonatorFlag ||
      item.entitlement === 'smenu-com-compensation' ||
      item.entitlement === 'smenu-ma-compensation' ||
      item.entitlement === 'smenu-com-book-business' ||
      item.entitlement === 'smenu-com-req-proposal' ||
      item.entitlement === 'smenu-com-training' ||
      item.entitlement === 'smenu-com-funding-solutions' ||
      item.entitlement === 'smenu-com-solutions-insights' ||
      item.entitlement === 'smenu-csb-incentives' ||
      item.entitlement === 'smenu-sgp-renewals' ||
      (isImpersonatorFlag && item.entitlement === 'smenu-ma-tools') ||
      (isImpersonatorFlag &&
        did0621ChangesEnabled &&
        (item.entitlement === 'smenu-ind-tools' ||
          item.entitlement === 'smenu-commercial-tools'))
        ? 1
        : 0) === 1
        ? 'menuLabelText subMenu'
        : 'menuLabelText subMenu text-disable'
    "
  >
    <span>
      {{ item.text }}
    </span>

    <span class="exticon">
      <cigna-icon
        class="icon-wrap"
        *ngIf="item.icon"
        type="{{ item.icon }}"
      ></cigna-icon>
    </span>
  </div>

  <div
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="afterMenu"
    class="sideNavSubMenu"
  >
    <mat-menu #afterMenu="matMenu" class="sideNavDrpDwn">
      <div>
        <a
          mat-menu-item
          *ngFor="let sItem of item.submenu"
          data-test-id="left-nav-sub-menu-overlay"
          target="{{
            (sItem.icon || sItem.isExternal) === 'external-link'
              ? '_blank'
              : '_self'
          }}"
          (click)="navItemSubSubMenuClicked(sItem)"
          [ngClass]="
            (!isImpersonatorFlag ||
            (isImpersonatorFlag &&
              (sItem.text === 'Medicare/Medicaid Eligibility' ||
                (did0621ChangesEnabled &&
                  (sItem.text === 'Find a Doctor or Dentist' ||
                    sItem.text === 'Find RX Medications' ||
                    sItem.text === 'Cigna.com' ||
                    sItem.text === 'Provider Directory' ||
                    sItem.text === 'Prescription Drug List' ||
                    sItem.text === 'Cigna for Employers' ||
                    sItem.text === 'Online Provider Directory' ||
                    sItem.text === 'Find RX Medications 2023' ||
                    sItem.text === 'Medicare Plan Finder' ||
                    sItem.text === 'Cigna Learning Center' ||
                    sItem.text === 'Marketing Review Submission' ||
                    sItem.text === 'Find RX Medications 2024' ||
                    sItem.text === 'Find RX Medications 2025' ||
                    sItem.text === 'YouTube'))))
              ? 1
              : 0) === 1
              ? 'menuLabelText subMenu'
              : 'menuLabelText subMenu text-disable'
          "
        >
          {{ sItem.text }}

          <cigna-icon
            *ngIf="item.text === 'Tools' && sItem.isExternal"
            [type]="'external-link'"
          ></cigna-icon>
          <cigna-icon
            *ngIf="item.text !== 'Tools'"
            type="{{ sItem.icon }}"
          ></cigna-icon>
        </a>
      </div>
    </mat-menu>
  </div>
</a>
